import { Link } from "react-router-dom";
import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import Step1PersonalDetails from "./Step1PersonalDetails";
import Step2ReviewPayment from "./Step2ReviewPayment";
import Step3Confirmation from "./Step3Confirmation";


const StepCard = ({ step, title, subtitle, active }) => (
  <div
    className="d-flex flex-column align-items-center position-relative"
    style={{ zIndex: 2 }}
  >
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${
        active
          ? "bg-primary text-white shadow"
          : "bg-dark text-muted border border-2 border-secondary"
      }`}
      style={{ width: 60, height: 60, fontSize: 18 }}
    >
      {step}
    </div>
    <div className="text-center mt-3">
      <h6
        className={`mb-1 fw-semibold ${active ? "text-light" : "text-muted"}`}
      >
        {title}
      </h6>
      <small
        className={`${
          active ? "text-primary" : "text-muted"
        } d-none d-md-block`}
      >
        {subtitle}
      </small>
    </div>
  </div>
);


const TournamentRegisterPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  
  // Progress Steps
  const steps = [
    { step: 1, title: "Personal Details", subtitle: "Basic info and contact", active: true },
    { step: 2, title: "Review & Payment", subtitle: "Confirm and pay" },
    { step: 3, title: "Confirmation", subtitle: "Registration success" },
  ];


  return (
    <div className="py-5">
      {/* Header */}
      <div className="text-center mb-5">
          <Link to={'/Tournaments'} className="d-inline-flex align-items-center text-muted mb-3">
          <FaArrowLeft className="me-2" /> Back to Tournaments
          </Link>
        <h1 className="fw-bold text-light mb-2 pt-0">
          International Coding Championship 2024
        </h1>
        <p className="text-muted">Join 3,247+ developers worldwide</p>
      </div>

      {/* Progress Steps */}
      <div className="row justify-content-center mb-5">
        <div className="col-md-10">
          <div className="d-flex align-items-center justify-content-between position-relative">
            {/* background line */}
            <div
              className="position-absolute w-100 bg-secondary rounded"
              style={{ height: 2, top: "50%", transform: "translateY(-50%)", zIndex: 1 }}
            ></div>

            {steps.map((s) => (
              <StepCard key={s.step} {...s} active={s.step === currentStep}/>
            ))}
          </div>
        </div>
      </div>
        {/* Render Current Step */}
      {currentStep === 1 && (
        <Step1PersonalDetails onNext={() => setCurrentStep(2)} />
      )}
      {currentStep === 2 && (
        <Step2ReviewPayment
          onBack={() => setCurrentStep(1)}
          onNext={() => setCurrentStep(3)}
        />
      )}
      {currentStep === 3 && <Step3Confirmation />}
    </div>
  );
};

export default TournamentRegisterPage;